import script from "./TabHolder.vue?vue&type=script&setup=true&lang=js"
export * from "./TabHolder.vue?vue&type=script&setup=true&lang=js"

import "./TabHolder.vue?vue&type=style&index=0&id=53801680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53801680"]])

export default __exports__